type InfoButtonProps = {
  onClick: () => void;
  className?: string;
};
const InfoButton = ({ onClick, className }: InfoButtonProps) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="26"
        cy="26"
        r="25"
        fill="black"
        fill-opacity="0.2"
        stroke="white"
      />
      <path
        d="M25.8608 37V20.6364H27.1499V37H25.8608ZM26.5107 17.7386C26.2266 17.7386 25.978 17.6392 25.7649 17.4403C25.5589 17.2415 25.456 17 25.456 16.7159C25.456 16.4318 25.5589 16.1903 25.7649 15.9915C25.9709 15.7926 26.2195 15.6932 26.5107 15.6932C26.7947 15.6932 27.0398 15.7926 27.2457 15.9915C27.4588 16.1903 27.5653 16.4318 27.5653 16.7159C27.5653 17 27.4624 17.2415 27.2564 17.4403C27.0504 17.6392 26.8018 17.7386 26.5107 17.7386Z"
        fill="white"
      />
    </svg>
  );
};

export default InfoButton;
